import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { XCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

const ErrorAlert = () => {
  const dispatch = useDispatch();
  const saveError = useSelector((state) => state.geofences.saveError);

  useEffect(() => {
    if (saveError) {
      const timer = setTimeout(() => {
        dispatch({ type: "CLEAR_GEOFENCE_FAILURE" });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [saveError, dispatch]);

  return saveError ? (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 transition-transform duration-500 ease-in-out">
      <Alert className="bg-red-600 text-white border-red-600 flex items-center p-3 rounded shadow-lg">
        <XCircle className="w-5 h-5 mr-2" />
        <AlertDescription className="text-white">
          {saveError}
        </AlertDescription>
      </Alert>
    </div>
  ) : null;
};

export default ErrorAlert; 